import * as PIXI from "pixi.js";
import { StartAppResize } from "../resizer";
import { ShowWinpopupOptions, WinPopup } from "./winpopup";
import { UserOptions } from "./settings";
import { EnumEventBus, EventBus } from "../EventBus";
import { AutoplayManager } from "./Autoplay";
import { CardScreen } from "./CardScreen";


export class Popup{
  app_popup!:PIXI.Application;
  winPopup!: WinPopup;
  settingsPopup!: UserOptions;
  autoplayPopup!: AutoplayManager;
  private overlay!: HTMLDivElement;

  constructor(private app_width: number, private app_height: number, private resize_to_device: number){
    (async() => {
      this.app_popup = new PIXI.Application();
      await this.app_popup.init({ width: this.app_width, height: this.app_height, backgroundAlpha: 0, resolution: 2 });
      document.body.appendChild(this.app_popup.canvas);
      StartAppResize({
        app: this.app_popup,
        app_width,
        app_height,
        resize_to_device: this.resize_to_device,
        transformOrigin_Y: 50,
        translate_Y: 50,
        app_top: 50,
        app_name: "app_popup"
      });
  
      this.addOverlay();
      this.setDisplay(false);
    })();
    EventBus.on(EnumEventBus.setSettingsPopup, (v: boolean) => this.setSettingsPopup(v));
    EventBus.on(EnumEventBus.setAutoplayPopup, (v: boolean) => this.setDisplay(v));
    EventBus.on(EnumEventBus.setAutoplayGame, (v: boolean) => v ? this.setDisplay(false) : "");
  }
  private addOverlay() {
    this.overlay = document.createElement("div");
    this.overlay.id = "popup-overlay";
    this.overlay.style.zIndex = "8";
    this.overlay.style.display = "none";
    document.body.appendChild(this.overlay);
  }
  private setDisplay = (isShown: boolean) => {
    this.app_popup.canvas.style.display = isShown ? "block" : "none";
    this.overlay.style.display = isShown ? "block" : "none";
  }
  addWinPopup = () => this.winPopup = this.app_popup.stage.addChild(new WinPopup({width: this.app_width, height: this.app_height}));
  addSettingsPopup = () => this.settingsPopup = this.app_popup.stage.addChild(new UserOptions(this.app_width, this.app_height));
  addAutoplayPopup(screenOrGetter: CardScreen | (() => CardScreen | undefined)) {
    this.autoplayPopup = this.app_popup.stage.addChild(new AutoplayManager(screenOrGetter));
    (window as any).autoplayPopup = this.autoplayPopup;
  }
  showWinPopup(amount: number | string, animOrOptions?: ShowWinpopupOptions, cb?: () => void){
    this.setDisplay(true);
    this.winPopup.showWinpopup(amount, animOrOptions, cb);
  }
  closeWinPopup(POPUP_HIDE_FALLBACK_MS: number) {
    return new Promise<void>((resolve) => {
      let settled = false;
      let timer: ReturnType<typeof setTimeout>;
      const onHidden = () => {
        if (settled) return;
        settled = true;
        this.winPopup.off?.("winpopup:hidden", onHidden);
        this.setDisplay(false);
        resolve();
      };
      this.winPopup.once?.("winpopup:hidden", onHidden);
      setTimeout(onHidden, POPUP_HIDE_FALLBACK_MS);
    });
  }
  setSettingsPopup(v: boolean) {
    if(v) {
      this.setDisplay(true);
      this.settingsPopup.show();
      return
    }
    this.setDisplay(false);
  }
} 
